import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-10 sm:py-12 px-4" data-id="element-116">
      <div className="max-w-xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-gold/30 p-6 sm:p-8 rounded-2xl text-center relative overflow-hidden" data-id="element-118">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-119" />
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-brand-orange/10 rounded-full blur-3xl" data-id="element-120" />

          <ShieldCheckIcon className="w-14 h-14 text-brand-gold mx-auto mb-5 relative z-10" data-id="element-121" />

          <h3 className="text-2xl sm:text-3xl font-black text-brand-cream uppercase mb-4 relative z-10" data-id="element-122">
            GARANZIA "CLASSE SODDISFATTA"
          </h3>

          <div className="text-gray-300 text-base sm:text-lg font-medium leading-relaxed relative z-10 space-y-2" data-id="element-123">
            <p data-id="element-124">
              Siamo così sicuri che il Sistema Integrato Italiano™ ti farà
              risparmiare ore ogni settimana, che ti diamo{' '}
              <strong className="text-brand-gold" data-id="element-125">30 giorni</strong> per
              provarlo in classe.
            </p>
            <p data-id="element-126">
              Se non hai già recuperato almeno{' '}
              <strong className="text-brand-gold" data-id="element-127">
                5 ore nella prima settimana
              </strong>{' '}
              — ti restituiamo ogni centesimo.
            </p>
            <p className="text-brand-cream font-bold" data-id="element-128">
              Senza domande. Senza complicazioni. Senza burocrazia.
            </p>
            <p className="text-xs text-gray-400 pt-2" data-id="element-129">
              📧 kitonline27@gmail.com
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}